export { AdsSlotObserverControllerSingleton as default };

/**
 * This class is responsible for observing the size of the ad slots and calling the on_resize callback when the size
 * changes. It uses the ResizeObserver API to observe the size of the ad slots.
 * The observe_allowed parameter is a function that checks if the callback should be called, it is used to avoid calling
 * it at every resize, it only calls it if observe_allowed() returns true, in this case the function passed checks if the
 * slot has been resized to a size different from the previous one.
 *
 * @author      William Lopes <william.c.lopes@meo.pt>
 * @copyright   Copyright (C) SAPO. All rights reserved.
 * @license     Private
 */
class AdsSlotObserverController
{
    observe(slot_item, observe_allowed, on_resize) {
        if (slot_item.getObserver() !== null) {
            return;
        }

        // o ResizeObserver dispara sempre um callback inicial (um bug do resizeobserver) ao comecar a observar.
        // Saltamos esse primeiro disparo. A flag e local a cada observer (um por slot) e
        // verificada ANTES do observe_allowed: assim o salto cai sempre no disparo inicial.
        let has_started = false;

        const observer = new ResizeObserver(() => {
            if (!has_started) {
                has_started = true;
                return;
            }

            if (!observe_allowed()) {
                return;
            }

            on_resize();
        });

        observer.observe(slot_item.getElement());

        slot_item.setObserver(observer);
    }
    
    unobserve(slot_item) {
        if (!slot_item.getObserver()) {
            return;
        }
        
        slot_item.getObserver().disconnect();
        slot_item.setObserver(null);
    }
}

const AdsSlotObserverControllerSingleton = new AdsSlotObserverController();
